import { ICostCenterHistoryResponse } from '../../../@types/cost-center-history.type';
import { getErrorMessage } from '../../../utils/utils';
import { Api } from '../ApiConfig';
import { ApiException } from '../ApiException';

export const getCostCenterHistoryByResourceId = async (resourceId: string) => {
  try {
    const { data } = await Api.get<ICostCenterHistoryResponse>(
      `api/Resource/CostCenterHistory/${resourceId}`
    );
    return data.result || [];
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar histórico de centro de custo'));
  }
};
